import { Box, Typography } from "@mui/material";
import PageContentEditor from "../../../components/PageContentEditor";
import { DataCodeEnum } from "../../../constants/enum";

const WhatIsTarot = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          padding: "10px",
        }}
      >
        <Typography
          color="primary"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
          }}
        >
          What is tarot?
        </Typography>
      </Box>
      <Box
        sx={{
          height: "calc(100vh - 60px)",
        }}
      >
        <PageContentEditor
          dataCode={DataCodeEnum.WHAT_IS_TAROT}
          dataName={"What is tarot?"}
        />
      </Box>
    </Box>
  );
};
export default WhatIsTarot;
